import React from 'react';
import PropTypes from 'prop-types';

export function StatusDot({ done = false, label = '' }) {
  return (
    <span
      className={`onyx-status-dot${done ? ' onyx-status-dot--done' : ''}`}
      data-testid="onyx-status-dot"
      data-done={done ? 'true' : 'false'}
      title={label}
      aria-label={label || (done ? 'complete' : 'incomplete')}
    />
  );
}

StatusDot.propTypes = {
  done: PropTypes.bool,
  label: PropTypes.string,
};
